import Constants from '../../../constants';

import { dataReducer } from './data';
import routeReducer from './routing';

let initialState: { [key: string]: any } = {};

export const getInitialState = () => {
  return initialState;
};

export const setInitialState = (appPayload: any) => {
  const payLoadData = appPayload.Data || appPayload.data;
  const { uiResources = {} } = appPayload;
  const contextData = uiResources[Constants.CONTEXT_DATA] || appPayload[Constants.CONTEXT_DATA];
  initialState = {
    data: {
      [Constants.APP.APP]: {
        ...payLoadData,
        [Constants.CONTEXT_DATA]: contextData
      }
    },
    containers: {}
  };
};

export const getRootReducer = (appPayload: any): any => {
  setInitialState(appPayload);
  return {
    data: dataReducer,
    containers: routeReducer
  };
};
